import { render, staticRenderFns } from "./choice-recalc-popup.vue?vue&type=template&id=24b56079&scoped=true&"
import script from "./choice-recalc-popup.vue?vue&type=script&lang=ts&"
export * from "./choice-recalc-popup.vue?vue&type=script&lang=ts&"
import style0 from "./choice-recalc-popup.vue?vue&type=style&index=0&id=24b56079&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b56079",
  null
  
)

export default component.exports